import React from "react"
import ThemeProvider from "@material-ui/styles/ThemeProvider"

import Layout from "../../../components/layout"
import SEO from "../../../components/seo"
import StudyRoutinePost from "../../../components/study-routine-post"
import theme from "../../../theme"

const summary = [
  {
    stage: "Primary",
    rhythm: "15 to 25 minutes, 4 days a week",
    focus: "Reading fluency, spelling, vocabulary, simple writing",
    habit: "Read aloud, talk about the text, then write one clear sentence",
  },
  {
    stage: "Lower secondary",
    rhythm: "25 to 40 minutes, 4 days a week",
    focus: "Comprehension, paragraph structure, grammar, evidence",
    habit: "Keep a quote bank and practise short analytical paragraphs",
  },
  {
    stage: "Upper secondary",
    rhythm: "45 to 60 minutes, 4 to 5 days a week",
    focus: "Essay planning, close analysis, comparative writing, exam timing",
    habit: "Write plans before full essays and review teacher feedback weekly",
  },
  {
    stage: "Exam block",
    rhythm: "Focused sessions plus rest",
    focus: "Timed responses, text knowledge, feedback, weak question types",
    habit: "Rotate reading, planning, writing, and correction instead of only rereading notes",
  },
]

const sections = [
  {
    title: "Primary: build reading confidence",
    paragraphs: [
      "English study in primary years should be warm and regular. Reading aloud, retelling stories, learning spelling patterns, and writing short responses all help students connect language with meaning.",
      "Keep writing tasks small: one strong sentence, one short paragraph, or one improved description is enough for many afternoons.",
    ],
  },
  {
    title: "Lower secondary: make paragraphs reliable",
    paragraphs: [
      "Students need a repeatable paragraph routine: topic sentence, evidence, explanation, and a link back to the question. This gives structure without making every response sound the same.",
      "A quote bank is useful if it includes notes about speaker, context, technique, and meaning rather than isolated memorised lines.",
    ],
  },
  {
    title: "Upper secondary: practise thinking before writing",
    paragraphs: [
      "Older students often improve fastest by planning before they write. Spend time unpacking questions, choosing evidence, building an argument, and ordering paragraphs.",
      "Full essays matter, but so do smaller tasks: introductions, body paragraphs, close analysis, comparative plans, and timed conclusions.",
    ],
  },
  {
    title: "A simple weekly rhythm",
    paragraphs: [
      "Use a calendar to schedule reading, vocabulary, paragraph practice, essay planning, timed writing, and feedback review.",
      "The most productive English routine has a loop: read carefully, write something specific, get feedback, and improve the next attempt.",
    ],
  },
]

const EnglishStudyRoutines = () => (
  <ThemeProvider theme={theme}>
    <Layout>
      <SEO
        title="English Study Plan by School Level"
        description="Plan English study routines for primary, lower secondary, upper secondary, and exam periods with reading, writing, analysis, and feedback habits."
      />
      <StudyRoutinePost
        subject="English"
        title="English study routines for different school levels"
        intro="A strong English routine balances reading, vocabulary, writing, analysis, and feedback so students build confidence one response at a time."
        sharedCalendarUrl="https://app.schoolcalendar.me/calendar/great-treefrog-72"
        image="blog-english.png"
        imageAlt="English study planning"
        summary={summary}
        sections={sections}
      />
    </Layout>
  </ThemeProvider>
)

export default EnglishStudyRoutines
